import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PriorityListLayer from "../components/PriorityListLayer";

const PriorityListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Priority' />

        {/* BlankPageLayer */}
        <PriorityListLayer />
      </MasterLayout>
    </>
  );
};

export default PriorityListPage;